import { useFlightContext } from "../../hooks/useFlightContext";
import type { HandlePromptsTabSelected } from "./AllPrompts.web.data";
import { useWorkgroups } from "./useWorkgroups.hook";

export type UseBookmarkPromptsProps = {
  handlePromptsTabSelected: HandlePromptsTabSelected;
};

export const useBookmarkPrompts = ({
  handlePromptsTabSelected,
}: UseBookmarkPromptsProps) => {
  useWorkgroups({ handlePromptsTabSelected });

  const { isFlightActive } = useFlightContext();
  return {
    isFlightActive,
  };
};
